<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <vx-card>
      <vs-table pagination max-items="10" search :data="_curriculumExternals">

        <template slot="thead">
          <vs-th sort-key="nameEn">(โครงการ)<br>(ระดับการศึกษา)<br>(ปีการศึกษา)<br>(คณะ [ในระบบ])<br>(หลักสูตร [ในระบบ])</vs-th>
          <vs-th sort-key="nameEn">(ระดับการศึกษา)<br>(ปีการศึกษา)<br>(คณะ [ภายนอก])<br>(หลักสูตร [ภายนอก])</vs-th>
          <vs-th sort-key="nameEn">(วันที่เริ่มเรียน)<br>(วันที่จบการศึกษส)<br>(ระยะเวลาหลักสูตร)<br>(จำนวนผู้ค้ำ)<br>(จำนวนผู้ค้ำเต็มจำนวน)</vs-th>
          <vs-th sort-key="nameEn">(ค่าขึ้นทะเบียน)<br>(ค่าลงทะเบียนตลอดหลักสูตร)<br>(ค่าธรรมเนียมการทำสัญญา)<br>(ค่าใช้จ่ายส่วนตัว)</vs-th>
          <vs-th sort-key="nameEn">(จำนวนงวด)<br>(ยอดชำระต่องวด)<br>(ยอดชำระไม่รวมค่าขึ้นทะเบียน)</vs-th>
          <vs-th sort-key="nameEn">สถานะ</vs-th>
          <vs-th sort-key="#" ></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="row" :key="index" v-for="(row, index) in data">
            <vs-td>
              ({{ `${row.project.nameTh}` }})<br>
              (-)<br>
              (-)<br>
              ({{ `${row.curriculum ? row.curriculum.faculty ? row.curriculum.faculty.nameTh : '-' : '-' }` }})<br>
              ({{ `${row.curriculum ? row.curriculum.nameTh : '-' }` }})
            </vs-td>
            <vs-td>
              ({{ `${row.degreeName}` }})<br>
              ({{ `${row.periodYear}/${row.periodTerm}` }})<br>
              ({{ `${row.facultyName}` }})<br>
              ({{ `${row.curriculumName}` }})
            </vs-td>
            <vs-td>
              ({{ `${row.startDate}` }})<br>
              ({{ `${row.graduationDate}` }})<br>
              ({{ `${row.regularYear} ปี` }})<br>
              ({{ `${row.suretyRequired} คน` }})<br>
              ({{ `${row.suretyFullRequired} คน` }})<br>
            </vs-td>
            <vs-td>
              ({{ `${$options.filters.numberFormat(row.registrationFee)}`}})<br>
              ({{ `${$options.filters.numberFormat(row.tuitionFee)}`}})<br>
              ({{ `${$options.filters.numberFormat(row.contractFee)}`}})<br>
              ({{ `${$options.filters.numberFormat(row.costOfLivingFee)}`}})
            </vs-td>
            <vs-td>
              ({{ `${row.periods}` }})<br>
              ({{ `${$options.filters.numberFormat(row.periodAmount)}` }})<br>
              ({{ `${$options.filters.numberFormat(row.periodAmountWithOutRegistrationFee)}` }})<br>
            </vs-td>
            <vs-td>
              <vx-tooltip  :text="row.notice" position="top" color="danger" v-if="row.status === 'Disabled'">
                <vs-chip :color="getStatusColor(row.status)" class="product-order-status">{{ row.status }}</vs-chip>
              </vx-tooltip>
              <vs-chip :color="getStatusColor(row.status)" class="product-order-status" v-if="row.status === 'Enabled'">{{ row.status }}</vs-chip>
            </vs-td>
            <vs-td>
              <vs-button @click="setForm(row)" color="primary" type="border">กำหนดหลักสูตร</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup title="กำหนดหลักสูตร" :active.sync="popupActive">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form1">
        <form @submit.prevent="handleSubmit" v-if="curriculumAdd === false">
          <div class="flex">
            <div class="mr-1 flex-1">
              <validation-provider :name="$t('sections.accounting.dataForm.curriculum')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.accounting.dataForm.curriculum')}}*</label>
                <v-select v-model="form1.curriculum" :clearable="true" :options="facultyCurriculumOptions" :name="$t('sections.accounting.dataForm.curriculum')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mt-6">
              <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" @click="toggleCurriculumAdd"></vs-button>
            </div>
          </div>
          <div class="flex">
            <div class="mr-1 flex-1">
              <validation-provider name="รวมยอดเงินกู้" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">รวมยอดเงินกู้*</label>
                <vs-input type="number" v-model="totalAmount" class="w-full" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider name="ค่าขึ้นทะเบียน" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ค่าขึ้นทะเบียน*</label>
                <vs-input type="number" v-model="registrationFee" class="w-full" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider name="ค่าลงทะเบียนตลอดหลักสูตร" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ค่าลงทะเบียนตลอดหลักสูตร*</label>
                <vs-input type="number" v-model="tuitionFee" class="w-full" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider name="ค่าธรรมเนียมการทำสัญญา" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ค่าธรรมเนียมการทำสัญญา*</label>
                <vs-input type="number" v-model="form1.contractFee" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="flex">
            <div class="mr-1 flex-1">
              <validation-provider name="จำนวนงวดชำระ" :rules="{required: true, min_value: 0.01}" v-slot="{ errors }">
                <label class="vs-input--label">จำนวนงวดชำระ*</label>
                <vs-input type="number" v-model="form1.periods" class="w-full" disabled="disabled" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider name="จำนวนผู้ค้ำประกัน" :rules="{required: true, min_value: 0.01}" v-slot="{ errors }">
                <label class="vs-input--label">จำนวนผู้ค้ำประกัน*</label>
                <vs-input type="number" v-model="form1.suretyRequired" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider name="จำนวนผู้ค้ำประกัน" :rules="{required: true, min_value: 0.01}" v-slot="{ errors }">
                <label class="vs-input--label">จำนวนผู้ค้ำประกันเต็มจำนวน*</label>
                <vs-input type="number" v-model="form1.suretyFullRequired" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="mr-1 flex-1">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form1.status" :clearable="false" :options="statusesOptions" name="status" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full">
              <div class="flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto" @click="popupActive = false">ยกเลิก</vs-button>
                <vs-button class="ml-2" @click="submit('form1')">บันทึก</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form2">
        <form @submit.prevent="handleSubmit" v-if="curriculumAdd === true" >
          <div class="flex">
            <div class="mr-1 flex-1">
              <validation-provider :name="$t('sections.master.dataForm.faculty')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.faculty") }}*</label>
                <v-select v-model="form2.faculty" :clearable="true" :options="facultiesOptions" :reduce="res => res.value" name="faculty" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="flex">
            <div class="mr-1 flex-1">
              <validation-provider :name="$t('sections.master.dataForm.curriculumNo')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.curriculumNo") }}*</label>
                <vs-input type="text" v-model="form2.curriculumNo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="flex-1">
              <validation-provider :name="$t('sections.master.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form2.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full">
              <div class="flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto" @click="curriculumAdd = false">ยกเลิก</vs-button>
                <vs-button class="ml-2" @click="submit('form2')">บันทึก</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
  </div>
</template>

<script>
import {createNamespacedHelpers, mapGetters} from 'vuex'
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import {ILoanType, IStatus} from "@/constants/interface";

const {mapActions: mapMasterActions, mapState: mapMasterFields} = createNamespacedHelpers('Master');

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      popupActive: false,
      curriculumAdd: false,
      registrationFee: 0,
      tuitionFee: 0,
      form2:{
        faculty: '',
        nameTh: '',
        nameEn: '',
        curriculumNo: '',
        status: IStatus.enabled,
        curriculumDetails: {
          loanType: ILoanType.principle,
          curriculumPeriod: 0,
          maximumLoanAmount: 0,
          contractPeriod: 0,
          paymentAmount: 0
        }
      },
      form1: {
        curriculum: '',
        periods: 0,
        periodAmount: 0,
        periodAmountWithOutRegistrationFee: 0,
        contractFee: 0,
        suretyRequired: 1,
        suretyFullRequired: 4,
        status: IStatus.enabled,
      },
    }
  },
  async created () {
    const vm = this
    const { getFaculties, getSearchCurriculums, getCurriculumExternals } = vm;
    const { facultiesOptions,  facultyCurriculumOptions  } = vm;
    if (facultiesOptions.length === 0) await getFaculties();
    if(facultyCurriculumOptions.length === 0) await getSearchCurriculums();
    await getCurriculumExternals();
    vm.pms ('MasterCurriculumExternal', 'visible', 'r')
    const obj = vm.curriculumExternals.find(res => res.isChoose === true)
    vm.isChoose = ( obj ? [obj.id] : [])
    vm.tableName = 'curriculumExternal'
  },
  computed: {
    ...mapGetters({
      facultiesOptions :'Master/facultiesOptions',
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      statusesOptions :'Master/statusesOptions'
    }),
    ...mapMasterFields(['curriculums', 'curriculumExternals', 'status']),
    totalAmount() {
      const vm = this;
      const { registrationFee, tuitionFee } = vm;
      return parseFloat(registrationFee + tuitionFee);
    },
    _curriculumExternals () {
      const vm = this
      return vm.curriculumExternals.map(res => {
        return {
          ...res,
          regularYear: res ? res.regularYear : 0,
          costOfLivingFee: res ? res.costOfLivingFee : 0,
          notice: res.status ===  IStatus.disabled ? res.notice : '',
          degreeName: `${res.periodYear} ${res.periodTerm}`,
          facultyName: res.curriculum ? res.curriculum.faculty ? res.curriculum.faculty.nameTh : '-' : '-',
          curriculumName: res.curriculum ? res.curriculum.nameTh : '-',
        }
      })
    }
  },
  methods: {
    ...mapMasterActions(['getFaculties', 'getSearchCurriculums', 'getCurriculums', 'getCurriculumExternals', 'deleteCurriculumExternal', 'createCurriculum', 'updateCurriculumExternal']),
    toggleCurriculumAdd (){
      const vm = this
      const facultyChoose = vm.facultiesOptions.find(res => res.isChoose === true)
      let max = Math.max.apply(Math, vm.curriculums.map(function(o) { return parseInt(o.curriculumNo); }))
      max++;
      vm.form2 = {
        faculty: (facultyChoose ? facultyChoose.value : ''),
        nameTh: '',
        nameEn: '',
        curriculumNo: ('0' + max).slice(-2),
        status: IStatus.enabled,
        curriculumDetails: {
          loanType: ILoanType.principle,
          curriculumPeriod: 0,
          maximumLoanAmount: 0,
          contractPeriod: 0,
          paymentAmount: 0
        }
      };
      vm.curriculumAdd = true;
    },
    setForm: function (row) {
      const vm = this
      vm.actionID = row.id
      const {registrationFee, tuitionFee, curriculum, periods, periodAmount, periodAmountWithOutRegistrationFee, contractFee, suretyRequired, suretyFullRequired} = row;
      vm.registrationFee = registrationFee;
      vm.tuitionFee = tuitionFee;
      vm.form1 = {
        curriculum: curriculum ? curriculum.id : '',
        periods: periods,
        periodAmount: periodAmount,
        periodAmountWithOutRegistrationFee: periodAmountWithOutRegistrationFee,
        contractFee: contractFee,
        suretyRequired: suretyRequired,
        suretyFullRequired: suretyFullRequired,
        status: IStatus.enabled,
      }
      vm.curriculumAdd = false;
      vm.popupActive = true;
    },
    async submit (type) {
      const vm = this
      const {createCurriculum, getSearchCurriculums, updateCurriculumExternal, getCurriculumExternals} = vm
      if (type === 'form1') {
        const { validate } = vm.$refs[type]
        validate().then(async success => {
          if (!success) {
            return
          }
          await updateCurriculumExternal({
            id: vm.actionID,
            form: {
              curriculum: {id: vm.form1.curriculum || ''},
              periods: parseInt(vm.form1.periods) || 0,
              periodAmount: parseFloat(vm.form1.periodAmount) || 0,
              periodAmountWithOutRegistrationFee: parseFloat(vm.form1.periodAmountWithOutRegistrationFee) || 0,
              contractFee: parseFloat(vm.form1.contractFee) || 0,
              suretyRequired: parseInt(vm.form1.suretyRequired) || 0,
              suretyFullRequired: parseInt(vm.form1.suretyFullRequired) || 0,
              status: vm.form1.status,
            },
            vm,
            redirect: null
          });
          await getCurriculumExternals();
          vm.popupActive = false;
        })
      } else {
        const { validate } = vm.$refs[type]
        validate().then(async success => {
          if (!success) {
            return
          }
          const curriculumId = await createCurriculum({
            form: {
              faculty: {id: vm.form2.faculty || ''},
              nameTh: vm.form2.nameTh,
              nameEn: vm.form2.nameEn,
              curriculumNo: vm.form2.curriculumNo,
              status: vm.form2.status,
              curriculumDetails: {
                loanType: vm.form2.curriculumDetails.loanType || '',
                curriculumPeriod: parseInt(vm.form2.curriculumDetails.curriculumPeriod) || 0,
                maximumLoanAmount: parseFloat(vm.form2.curriculumDetails.maximumLoanAmount) || 0,
                contractPeriod: parseInt(vm.form2.curriculumDetails.contractPeriod) || 0,
                paymentAmount: parseFloat(vm.form2.curriculumDetails.paymentAmount) || 0
              },
            },
            vm,
            redirect: null
          });
          await getSearchCurriculums();
          vm.curriculumAdd = false;
          vm.form1.curriculum = curriculumId;
        })
      }
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style>
.vs-popup {
  width: 800px !important;
  height: auto;
}
.vs-popup--content {
  width: auto !important;
  padding: 1rem;
  font-size: 1rem;
}
</style>
